var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cart-content-wrapper-component ccwc"},[_c('CartStepsHeader',{attrs:{"step":_vm.step},on:{"on-step-change":_vm.navigateToStep}}),_vm._v(" "),_c('b-container',[_c('b-row',[_c('b-col',[_c('h1',{staticClass:"ccwc__h1"},[_vm._v(_vm._s(_vm.stepName))]),_vm._v(" "),_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }